/*import fesicol from "./server/fesicol";
import cooservunal from "./server/cooservunal";
import cidesa from "./server/cidesa";
import crd from "./server/crd";
import crediflores from "./server/crediflores"; */
import l3af from "./server/l3af";
import bejuco from "./server/bejuco";
import staging from "./server/staging";

export default {
    dev_l3af: l3af.dev_l3af,
    pruebas_l3af: l3af.pruebas_l3af,
    production_l3af: l3af.production_l3af,
    prod_bejuco: bejuco.prod_bejuco,
    staging_l3af: staging.prod_bejuco
};
